import { render } from "./OutilPersonnalisation.vue?vue&type=template&id=0aaafbb0&scoped=true"
import script from "./OutilPersonnalisation.vue?vue&type=script&lang=js"
export * from "./OutilPersonnalisation.vue?vue&type=script&lang=js"

import "./OutilPersonnalisation.vue?vue&type=style&index=0&id=0aaafbb0&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aaafbb0"]])

export default __exports__